import {
  Columns2,
  FileOutput,
  FilePenLine,
  FileText,
  ImagePlus,
  Images,
  Lock,
  Minimize2,
  PenLine,
  Presentation,
  TextCursorInput,
  type LucideIcon,
} from 'lucide-react';

export interface ToolDef {
  id: string;
  path: string;
  title: string;
  description: string;
  icon: LucideIcon;
  /** Accent colour for the card and page header. */
  accent: string;
  badge?: string;
}

export const TOOLS: ToolDef[] = [
  { id: 'edit', path: '/edit', title: 'Edit PDF', description: 'Change text in text-based or scanned PDFs. OCR, AI rewrite and form fill included.', icon: FilePenLine, accent: '#ff3d8d' },
  { id: 'compress', path: '/compress', title: 'Compress PDF', description: 'Reduce PDF file size while keeping quality as high as possible.', icon: Minimize2, accent: '#7ed957' },
  { id: 'compare', path: '/compare-pdf', title: 'Compare PDF', description: 'Compare two PDF versions side by side and highlight visual and text changes.', icon: Columns2, accent: '#6f93c7', badge: 'New' },
  { id: 'pdf-to-word', path: '/pdf-to-word', title: 'PDF to Word', description: 'Turn the text in a PDF into an editable DOCX document.', icon: FileText, accent: '#6b8be6' },
  { id: 'pdf-to-powerpoint', path: '/pdf-to-powerpoint', title: 'PDF to PowerPoint', description: 'Turn PDF pages into PPTX slides, as images or as editable text.', icon: Presentation, accent: '#f2784b' },
  { id: 'word-to-pdf', path: '/word-to-pdf', title: 'Word to PDF', description: 'Make DOCX files easy to read by converting them to PDF.', icon: FileOutput, accent: '#6b8be6' },
  { id: 'pdf-to-jpg', path: '/pdf-to-jpg', title: 'PDF to JPG', description: 'Convert each PDF page into a JPG, or extract all images contained in a PDF.', icon: Images, accent: '#d9c74a' },
  { id: 'jpg-to-pdf', path: '/jpg-to-pdf', title: 'JPG to PDF', description: 'Combine images into one PDF. Adjust order, orientation and margins.', icon: ImagePlus, accent: '#d9c74a' },
  { id: 'sign', path: '/sign-pdf', title: 'Sign PDF', description: 'Draw, type or upload your signature and place it on any page.', icon: PenLine, accent: '#6f93c7' },
  { id: 'protect', path: '/protect-pdf', title: 'Protect PDF', description: 'Encrypt a PDF with a password (AES-256) to prevent unauthorized access.', icon: Lock, accent: '#6f93c7' },
  { id: 'forms', path: '/pdf-forms', title: 'PDF Forms', description: 'Fill PDF forms, add fillable fields, or detect fields automatically.', icon: TextCursorInput, accent: '#b678a8', badge: 'New' },
];

export function getTool(id: string): ToolDef {
  const tool = TOOLS.find((candidate) => candidate.id === id);
  if (!tool) throw new Error(`Unknown tool: ${id}`);
  return tool;
}
